import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
  const userData = JSON.parse(localStorage.getItem('userData'));

  return userData ? element : <Navigate to="/" />;
};

export default PrivateRoute;
